import { getClient } from '@zg-rentals/ts-client-http-client';
import { setClient as setRenterInfoClient } from '@zg-rentals/ts-renter-info-client/client';

export const renterInfoClient = getClient().extend({
  prefixUrl: process.env.NEXT_PUBLIC_PREFIX_URL,
});

// Configure the renter-info module instance, too.
setRenterInfoClient(renterInfoClient);
